module.exports = __webpack_public_path__ + "media/images/icon_list/icon_notification_comment-e0d22b635b0db2c04935e2bda7deebec.svg";